import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CoreModule } from "../../core/core.module";
import { CalculateModule } from "../../calculator/calc.module";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { GeneralRoutingModule } from "./general-routing.module";
import { GeneralComponent } from "./general/general.component";
import { RegTableComponent } from "./components/reg-table/reg-table.component";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { FormsModule } from "@angular/forms";
import {MatLegacyProgressSpinnerModule as MatProgressSpinnerModule} from "@angular/material/legacy-progress-spinner";
import { ScoreCardComponent } from "./components/score-card/score-card/score-card.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CompanyDialogComponent } from './components/company-dialog/company-dialog.component';



@NgModule({
  imports: [CommonModule, GeneralRoutingModule, CoreModule, CalculateModule, MatCardModule, ScrollingModule,
    MatProgressSpinnerModule, FormsModule, BrowserAnimationsModule, MatTooltipModule, NgxSpinnerModule],
  declarations: [GeneralComponent, RegTableComponent, ScoreCardComponent, CompanyDialogComponent],
  exports: [GeneralComponent]
})
export class GeneralModule {}
